import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  label: {
    color: "#004481",
    fontWeight: 600,
    fontSize: "0.85rem",
    marginBottom: 4,
  },
}));
